import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import cx from '@/utils/cx';
import useStyle from './style';

const InputBase = forwardRef(({
  className,
  disabled,
  type,
  placeholder,
  readonly,
  value,
  onChange,
  ...rest
}, ref) => {
  const classes = useStyle();

  return (
    <input
      ref={ref}
      type={type}
      {...(disabled ? { disabled: true } : {})}
      {...(readonly ? { readonly: true } : {})}
      className={cx(
        classes.inputBase,
        className,
      )}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      autoCorrect="off"
      {...rest}
    />
  );
});


InputBase.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf([
    'button', 'checkbox', 'email', 'hidden', 'number', 'search',
    'password', 'radio', 'range', 'submit', 'tel', 'text', 'url',
  ]),
  placeholder: PropTypes.string,
  readonly: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

InputBase.defaultProps = {
  className: '',
  disabled: false,
  placeholder: '',
  type: 'text',
  readonly: false,
  value: '',
  onChange: () => { },
};

export default InputBase;
